import { isAdriagate } from 'modules/_common';

const RENTISTIC_SUPPORT_EMAIL = 'support@rentistic.hr';
const ADRIAGATE_SUPPORT_EMAIL = 'info@adriagate.com';

const RENTISTIC_PP_URL = 'https://www.rentistic.com/hr/politika-privatnosti';
const ADRIAGATE_PP_URL = `https://rentistic.adriagate.com/documents/privacy-policy_ag.html`;

const RENTISTIC_TOS_URL = 'https://www.rentistic.com/hr/opci-uvjeti';

export const SUPPORT_EMAIL = isAdriagate ? ADRIAGATE_SUPPORT_EMAIL : RENTISTIC_SUPPORT_EMAIL;
export const PRIVACY_POLICY_URL = isAdriagate ? ADRIAGATE_PP_URL : RENTISTIC_PP_URL;
export const TERMS_OF_SERVICE_URL = RENTISTIC_TOS_URL;
